import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SiteDto} from '../../objects/site.dto';
import {DataService} from '../../../../services/data.service';
import {ServiceTechnicianDtoModel} from '../../../../models/service-technician-dto.model';

@Component({
  selector: 'app-site-detail-modal',
  templateUrl: './site-detail-modal.component.html',
  styleUrls: ['./site-detail-modal.component.scss']
})
export class SiteDetailModalComponent implements OnInit {
  @Input() public modalControl = {showModal: false};
  @Input() public site: SiteDto;
  @Input() public isPlanner: boolean;
  @Output() public updatedSite: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public moveSite: EventEmitter<SiteDto> = new EventEmitter<SiteDto>();

  serviceTechnicians: ServiceTechnicianDtoModel[] = [];

  public editMode = false;

  public editSite: SiteDto;

  constructor(private dataService: DataService) {
  }

  async ngOnInit(): Promise<void> {
    this.serviceTechnicians = await this.dataService.getAllServiceTechnicians() as ServiceTechnicianDtoModel[];
  }

  closeModal() {
    this.editMode = false;
    this.modalControl.showModal = false;
  }

  getGoogleMapsLink(): string {
    const address = this.site.street + '+' + this.site.streetNumber + ',+' + this.site.postCode + '+' + this.site.city;
    return 'https://www.google.com/maps?q=' + address;
  }

  canEdit(): boolean {
    return this.isPlanner && this.site && this.site.siteInstallationState === 'PLANNED';
  }

  enableEditMode() {
    if (this.canEdit()) {
      this.editSite = {...this.site};
      this.editMode = true;
    }
  }

  movePin() {
    this.moveSite.emit(this.site);
    this.closeModal();
  }

  disableEditMode() {
    if (this.isPlanner) {
      this.editMode = false;
    }
  }

  canSaveSite(): boolean {
    return this.isPlanner && this.editSite && this.isNotBlank(this.editSite.street) &&
      this.isNotBlank(this.editSite.streetNumber) &&
      this.isNotBlank(this.editSite.postCode) && this.isNotBlank(this.editSite.city);
  }

  async saveSite() {
    if (this.canSaveSite()) {
      await this.dataService.updatePlannedSite(this.editSite);
      this.updatedSite.emit(true);
      this.editMode = false;
      this.closeModal();
    }
  }

  editStreet(event: any) {
    this.editSite.street = event;
  }

  editStreetNumber(event: any) {
    this.editSite.streetNumber = event;
  }

  editPostCode(event: any) {
    this.editSite.postCode = event;
  }

  editCity(event: any) {
    this.editSite.city = event;
  }

  editLatitude(event: any) {
    this.editSite.latitude = event;
  }

  editLongitude(event: any) {
    this.editSite.longitude = event;
  }

  editAdditionalName(event: any) {
    this.editSite.additionalName = event;
  }

  editSalesforceId(event: any) {
    this.editSite.salesforceId = event;
  }

  editContactPersonName(event: any) {
    this.editSite.contactPersonName = event;
  }

  editContactPersonNumber(event: any) {
    this.editSite.contactPersonNumber = event;
  }

  editInstallationPersonEmail(event: any) {
    this.editSite.installationPersonEmail = event;
  }

  editInstallationWeek(event: any) {
    this.editSite.installationWeek = event;
  }

  editNotes(event: any) {
    this.editSite.note = event;
  }

  private isNotBlank(value: string): boolean {
    return value && value !== null && value !== "";
  }
}
